/**
 * Determines if the operating system is MacOS.
 */
export function isMacOS(): boolean {
  const platform = navigator?.platform?.toLowerCase() || '';
  if (platform.includes('mac')) {
    return true;
  }
  const ua = navigator?.userAgent?.toLowerCase() || '';
  return ua.includes('macintosh');
}
